import guideQuery from '@/services/gql/types/Guides/queries/guidesNames.gql'
import organizationQuery from '@/services/gql/types/CulturalOrganizations/queries/culturalOrganizationsNames.gql'
import touristAgencyQuery from '@/services/gql/types/TouristAgencies/queries/touristAgenciesNames.gql'
import eventOrganizerQuery from '@/services/gql/types/EventOrganizers/queries/eventOrganizersNames.gql'
import hotelQuery from '@/services/gql/types/Hotels/queries/hotelsNames.gql'

export const queries = {
  GUIDE: guideQuery,
  ORGANIZATION: organizationQuery,
  TOURIST_AGENCY: touristAgencyQuery,
  EVENT_ORGANIZER: eventOrganizerQuery,
  HOTEL: hotelQuery
}

export const variables = (value = null) => {
  return {
    GUIDE: { where: { name_contains: value }, limit: 7 },
    ORGANIZATION: { where: { organizationName_contains: value }, limit: 7 },
    TOURIST_AGENCY: { where: { name_contains: value }, limit: 7 },
    EVENT_ORGANIZER: { where: { organizerName_contains: value }, limit: 7 },
    HOTEL: { where: { title_contains: value }, limit: 7 }
  }
}

export const returnName = {
  GUIDE: 'name',
  ORGANIZATION: 'organizationName',
  TOURIST_AGENCY: 'name',
  EVENT_ORGANIZER: 'organizerName',
  HOTEL: 'title'
}
